module.exports = __webpack_public_path__ + "img/poly-1.e1bba09b.png";